var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./vmpSyncConfirmPopup.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-047fb8cd\",\"hasScoped\":false}!./vmpSyncConfirmPopup.html"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/vmpSyncConfirmPopup/vmpSyncConfirmPopup.vue
// module id = 2745
// module chunks = 1